import {gsap} from "gsap";


class Accordion {
	static instance = null;

	static create(options) {

		if (!Accordion.instance) {
			Accordion.instance = new Accordion(options);
		}
	}

	static get defaultOptions() {
		return {
			element: null,
			trigger: '[data-accordion-trigger]',
			content: '[data-accordion-content]',
			container: document,
			//smoother: null
		}
	}

	static destroy() {
		if (Accordion.instance) {
			Accordion.instance.beforeDestroy();
			Accordion.instance = null;
		}


	}

	constructor(options) {
		this.accordionArray = [];
		this.options = Object.assign({}, Accordion.defaultOptions, options);
		this.accordion = this.options.container.querySelectorAll(this.options.element);
		this.setup();
		this.init();
	}

	setup() {
		this.accordion.forEach(accordion => {
			let accordionTriggers = [...accordion.querySelectorAll(this.options.trigger)];
			this.accordionArray = accordionTriggers.map((trigger, i) => {
				return {
					trigger: trigger,
					content: trigger.nextElementSibling,
					index: i,
					background: trigger.getAttribute('data-accordion-background'),
					lastHeight: trigger.nextElementSibling.scrollHeight,
					height: trigger.nextElementSibling.scrollHeight,
					isActive: i === 0 ? true : false,
					animation: gsap.timeline({
						paused: true,
						reversed: true,
						defaults: {
							duration: 0.3,
							ease: "power4.out",
							transformOrigin: 'center top',
						}
					})
						.fromTo(trigger.nextElementSibling, {
							height: '100%',
							overflow: 'hidden',
							padding: '40px 0 20px 0',
						}, {
							height: 0,
							padding: 0,
							duration: 0.3,
							overflow: 'hidden',
						})
				}
			})
		})
	}


	init() {
		this.accordionArray.forEach((accordion, i) => {
			// first init
			this.toggleAccordion(accordion);

			// add event listener to trigger
			accordion.trigger.addEventListener('click', (e) => {
				e.preventDefault();
				// toggle animation
				this.toggleAccordion(accordion, this.getScrollPosition);

				// scroll to accordion
				this.scrollToAnimation(accordion.trigger);

				// change background
				if (accordion.background) {
					this.backgroundAnimation(accordion.background);
				}
			})
		})
	}

	scrollToAnimation(target) {
		if (typeof window.scroller !== 'undefined') {
			window.scroller.scrollTo(target, {
				offset: document.querySelector('header').offsetHeight * -1,
				duration: 1000,
			})

		} else {
			gsap.to(window, {
				scrollTo: {
					y: target,
					offsetY: document.querySelector('header').offsetHeight,
				},
				duration: 1,
				ease: 'power4.inOut',
			})
		}

	}

	toggleAccordion(accordion, scrollPosition) {
		if (accordion.isActive) {
			accordion.animation.reverse().eventCallback('onReverseComplete', () => {
				let invert = 1;
				gsap.timeline()
					.set(accordion.content.querySelectorAll('[data-stagger-slide-up]'), {alpha: 0, y: 50})
					.to(accordion.content.querySelectorAll('[data-stagger-slide-up]'), {
						alpha: 1,
						duration: 1,
						y: 0,
						ease: "power4.out",
						transformOrigin: 'center top',
						stagger: 0.1 * invert,
					})
			});
			accordion.isActive = false;
			accordion.trigger.classList.add('active')
		} else {
			accordion.animation.play(0).eventCallback('onComplete', () => {
				gsap.set(accordion.content.querySelectorAll('[data-stagger-slide-up]'), {alpha: 0, y: 50})
			})

			accordion.isActive = true;
			accordion.trigger.classList.remove('active');
		}
	}

	get getScrollPosition() {
		return window.pageYOffset || document.documentElement.scrollTop;
	}

	toggleScrolling() {
		return {
			enabled: true,
			events: 'scroll,wheel,touchmove,pointermove'.split(','),
			prevent: e => {
				console.log(e)
				e.preventDefault();
			},
			disable: () => {
				if (this.toggleScrolling().enabled) {
					this.toggleScrolling().enabled = false;
					window.addEventListener('scroll', gsap.ticker.tick, {passive: true});
					this.toggleScrolling().events.forEach((e, i) => {
							document.querySelector('#smooth-wrapper').addEventListener(e, this.toggleScrolling().prevent, {
								passive: false,
							})
						}
					);
				}
			},
			enable: () => {
				if (!this.toggleScrolling().enabled) {
					this.toggleScrolling().enabled = true;
					window.removeEventListener('scroll', gsap.ticker.tick);
					this.toggleScrolling().events.forEach((e, i) =>
						(i ? document : window).removeEventListener(e, this.toggleScrolling().prevent));
				}
			},
		};
	}

	lockScroll(e) {
		e.preventDefault();
	}

	beforeDestroy() {
		this.accordion = null;
		this.accordionArray = null;
	}

	backgroundAnimation(background) {
		const target = document.getElementById('bg-main')
		target.classList.remove(...target.classList);
		target.classList.add('bg-transition', background);
	}


}

export {Accordion as default}